// extracted by mini-css-extract-plugin
module.exports = {"root":"HOrderCard_root__26hbS","noEdit":"HOrderCard_noEdit__3P-6X","noEditP":"HOrderCard_noEditP__2euBu","header":"HOrderCard_header__10BQ9","footer":"HOrderCard_footer__3wTNt"};